import amplitude from 'amplitude-js'
import partialRight from 'lodash-es/partialRight'

export const initAmplitude = () => {
  try {
    amplitude.getInstance().init(import.meta.env.VITE_APP_AMPLITUDE, '', {
      includeGclid: true,
      includeReferrer: true,
      includeUtm: true,
    })
  } catch (error: any) {
    console.error('[Amplitude]: Failed call init', error)
  }
}
export const getAmplitudeDeviceId = () => {
  try {
    return amplitude.getInstance().getDeviceId()
  } catch (error: any) {
    console.error('[Amplitude]: Failed to call getDeviceId', error)

    return null
  }
}

export const getAmplitudeIdentify = () => {
  try {
    return new amplitude.Identify()
  } catch (error: any) {
    console.error('[Amplitude]: Failed to call getIdentify', error)

    return null
  }
}

export const setAmplitudeIdentify = (payload) => {
  try {
    amplitude.identify(payload)
  } catch (error: any) {
    console.error('[Amplitude]: Failed to call setIdentify', error)
  }
}

export const setAmplitudeProp = (propName, value, once = false) => {
  const identify = getAmplitudeIdentify()

  if (once) {
    identify.setOnce(propName, value)
  } else {
    identify.set(propName, value)
  }
  setAmplitudeIdentify(identify)
}

export const setAmplitudePropOnce: (propName, value) => void = partialRight(setAmplitudeProp, true)

export const setAmplitudeUserId = (userId) => {
  try {
    amplitude.getInstance().setUserId(userId)
  } catch (error: any) {
    console.error('[Amplitude]: Failed to call setUserId', error)
  }
}

export const logAmplitudeEvent = (eventType, eventProperties) => {
  try {
    amplitude.getInstance().logEvent(eventType, eventProperties)
  } catch (error: any) {
    console.error('[Amplitude]: Failed to call logEvent', error)
  }
}

export const logGtmEvent = (event: { event: string }) => {
  window.dataLayer = window.dataLayer || []

  window.dataLayer.push(event)
}
